import produce from 'immer';
import { SET_SELECTED_OPTION } from '../../constants';

const initialState = {
    options: [],
    selected: null,
    modifier: 'pdp'
};

const volumeDiscount = produce((state, action) => {
    const { type, payload } = action;

    // eslint-disable-next-line default-case
    switch (type) {
        case SET_SELECTED_OPTION:
            state.selected[payload.eanId] = payload.option;
            break;
    }
}, initialState);

export default volumeDiscount;
